import comp from "./Home";
export default comp;
